<div class="qr-overlay" (click)="close()">
  <div class="qr-modal" (click)="$event.stopPropagation()">
    <div class="qr-header">
      <h3>{{ title }}</h3>
      <button type="button" class="qr-close" (click)="close()">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M6 6l8 8M14 6l-8 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
      </button>
    </div>

    <div class="qr-body">
      <div class="qr-canvas-wrap">
        @if (generating()) {
        <div class="qr-loading"><span class="mini-spinner"></span></div>
        } @else if (dataUrl()) {
        <img [src]="dataUrl()" alt="二维码" class="qr-img" />
        } @else {
        <div class="qr-error">{{ error() || '二维码生成失败' }}</div>
        }
      </div>
      @if (hint) {
      <p class="qr-hint">{{ hint }}</p>
      }

      <div class="qr-link-box">
        <span class="qr-link-text">{{ url }}</span>
        <button type="button" class="qr-link-copy" (click)="copyLink()">复制</button>
      </div>

      <div class="qr-actions">
        @if (isApp) {
        <div class="qr-actions-row">
          <button type="button" class="qr-btn qr-btn-primary" [disabled]="!dataUrl()" (click)="shareImage()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M4 12v8a1 1 0 001 1h14a1 1 0 001-1v-8M16 6l-4-4-4 4M12 2v13" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            分享二维码
          </button>
          <button type="button" class="qr-btn qr-btn-ghost" [disabled]="!dataUrl()" (click)="saveToAlbum()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M4 4h4M16 4h4M4 20h4M16 20h4M4 8v8M20 8v8M8 12h8" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" />
            </svg>
            保存到相册
          </button>
        </div>
        } @else {
        <button type="button" class="qr-btn qr-btn-primary" [disabled]="!dataUrl()" (click)="downloadQr()">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" stroke="currentColor"
              stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          下载二维码
        </button>
        }
        <button type="button" class="qr-btn qr-btn-ghost" (click)="copyLink()">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M10 14a5 5 0 007.07 0l3-3a5 5 0 00-7.07-7.07l-1.5 1.5" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" />
            <path d="M14 10a5 5 0 00-7.07 0l-3 3a5 5 0 007.07 7.07l1.5-1.5" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          复制链接
        </button>
      </div>
    </div>
  </div>
</div>